import React from "react";
import { Modal } from "../../../components";
import { ButtonPrimary, ButtonSecondary } from "components/Atoms/Button";
import ContactNewModal from "contact/new/App";
import ContactModalPicker from "components/Picker/ContactPicker/ContactModalPicker";

interface Props {
  company: server.dto.Company
  onClose: (hasChanged: boolean) => void
  excludeKeys: number[]
}

const AddNewModal = (props: Props) => {
  const [displaySelectContactModal, setDisplaySelectContactModal] = React.useState(false);
  const [displayNewContactModal, setDisplayNewContactModal] = React.useState(false);

  const onNewContactClicked = () => {
    setDisplayNewContactModal(true);
  };

  const onContactCreated = async (contact: server.dto.Contact) => {
    const res = await window.CoreApi.CompanyToContact.SetLink({
      companyId: props.company.companyId,
      contactId: contact.contactId,
      isActive: true
    });

    if (res.data.hasErrors) {
      window.displayGenericModal("Error", res.data.errors[0].message, "tiny", "red");
      return;
    }

    props.onClose(true);
  }

  const onContactSelected = async (contact: server.dto.ContactSmallV2) => {
    const res = await window.CoreApi.CompanyToContact.SetLink({
      companyId: props.company.companyId,
      contactId: contact.contactId,
      isActive: true
    });

    if (res.data.hasErrors) {
      window.displayGenericModal("Error", res.data.errors[0].message, "tiny", "red");
      return;
    }

    props.onClose(true);
  };

  return <>
    <Modal
      title={""}
      style={{ width: 350 }}
      displayHeader={false}
      isOpen
      gap="regular"
      handleClose={() => { props.onClose(false); }}
    >
      <ButtonPrimary
        onClick={onNewContactClicked}
        label={RESX.Contact.NewContactPerson}
      />

      <ButtonSecondary
        onClick={() => { setDisplaySelectContactModal(true); }}
        label={RESX.Contact.LinkExistingContact}
      />
    </Modal>

    {displaySelectContactModal && <ContactModalPicker
      startOpen
      value={undefined}
      onChange={onContactSelected}
      required={false}
      canCreateNew={false}
      validatorKey="contactModalPicker"
    />}

    <ContactNewModal
      isOpen={displayNewContactModal}
      onClose={() => setDisplayNewContactModal(false)}
      onCreated={onContactCreated}
    />
  </>;
};

export default AddNewModal;